/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Gpsubreasonplaceholder4Inputs */

const en_coinvestments_declinedeal_gpsubreasonplaceholder4 = /** @type {(inputs: Coinvestments_Declinedeal_Gpsubreasonplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a sub-reason`)
};

/**
* | output |
* | --- |
* | "Select a sub-reason" |
*
* @param {Coinvestments_Declinedeal_Gpsubreasonplaceholder4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_gpsubreasonplaceholder4 = /** @type {((inputs?: Coinvestments_Declinedeal_Gpsubreasonplaceholder4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Gpsubreasonplaceholder4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_gpsubreasonplaceholder4(inputs)
});
export { coinvestments_declinedeal_gpsubreasonplaceholder4 as "coInvestments_declineDeal_gpSubreasonPlaceholder" }